export default {"src":"/_next/static/media/blue-local.761d39b0.svg","height":33,"width":113,"blurWidth":0,"blurHeight":0};